import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroSection() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: buttonRef,
    isVisible: buttonVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section data-section-id="38805" id="our-mission" className="relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden bg-[var(--background)] text-[var(--foreground)]" style={{
    "--background": "42 71% 97%",
    "--foreground": "24 10% 10%",
    "--primary": "42 71% 97%",
    "--secondary": "43 59% 90%",
    "--accent": "26 91% 37%",
    "--muted": "24 10% 10%",
    "--border": "43 59% 90%"
  } as React.CSSProperties}>
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,hsl(var(--foreground)/0.03)_1px,transparent_1px)] bg-[size:8.33%_100%]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,hsl(var(--accent)/0.05),transparent_70%)]" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 py-20 text-center md:py-32">
        <div ref={textRef} className={`mx-auto max-w-4xl transition-all duration-1000 ease-out ${textVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <div className="mb-8 inline-block rounded-full border border-[hsl(var(--accent))] px-4 py-1.5 text-xs font-semibold tracking-widest text-[hsl(var(--accent))] uppercase">
            Institutional AI Infrastructure Capital
          </div>
          <h1 className="mb-6 text-4xl font-extrabold tracking-tighter text-[hsl(var(--foreground))] font-sans sm:text-5xl md:text-6xl lg:text-7xl">
            Deploying Capital Into the <br className="hidden md:block" />
            <span className="text-[hsl(var(--accent))]">Backbone</span> of AI
          </h1>
          <p className="mx-auto mb-10 max-w-2xl text-lg text-[hsl(var(--foreground)/0.7)] font-serif md:text-xl">
            N2N Capital architects the foundational infrastructure for the machine age, 
            providing strategic capital and technical expertise to the world's most 
            ambitious neural networks.
          </p>
        </div>

        <div ref={buttonRef} className={`flex flex-col items-center justify-center gap-4 transition-all duration-1000 delay-300 ease-out sm:flex-row ${buttonVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <Button asChild size="lg" className="h-12 px-8 text-base rounded-md bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))] transition-all hover:opacity-90 shadow-[hsl(var(--foreground)/0.1)]">
            <Link to="#">
              Explore Our Thesis
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-12 px-8 text-base rounded-md border-[hsl(var(--foreground))] text-[hsl(var(--foreground))] hover:bg-[hsl(var(--foreground)/0.05)]">
            <Link to="#">Intelligence Engine</Link>
          </Button>
        </div>
      </div>
    </section>;
}